// extracted by mini-css-extract-plugin
export default {"flexp":"addaddress_flexp__Nlj2V","flex":"addaddress_flex__dkVLN","box":"addaddress_box__Aho6K"};